import React, { useState } from "react";
import "../styles/Contact.css";
import axios from "axios";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    serviceType: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firstName || !formData.email) {
      alert("Please fill all required fields");
      return;
    }

    try {
      await axios.post("https://backend.venturebiz.in/send", formData);
      alert("Message sent successfully!");
    } catch {
      alert("Failed to send message");
    }

    setFormData({
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      serviceType: "",
      message: "",
    });
  };

  return (
    <section className="contact fade-in" id="contact">
      <h2>Contact Us</h2>
      <div className="contact-container">
        {/* Form */}
        <div className="contact-form">
          <h3>Send a Message</h3>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <select
              name="serviceType"
              value={formData.serviceType}
              onChange={handleChange}
              required
            >
              <option value="">Select Service Type</option>
              <option value="GCC">GCC</option>
              <option value="Consultancy">Consultancy</option>
              <option value="Learning & Development">
                Learning & Development
              </option>
            </select>
            <textarea
              name="message"
              placeholder="Your Message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit" className="btn-submit">
              Submit
            </button>
          </form>
        </div>

        {/* Info */}
        <div className="contact-info">
          <h3>Our Location</h3>
          <p>
            #2085/16, 2nd Floor, Spoorthi, Wilson Garden Society Layout,
            Puttenahalli Main Road, JP Nagar 7th Phase, Bangalore- 560078.{" "}
            <br />
            <br />
            Website: www.venturebiz.in. <br />
          </p>

          <h3>Contact Number</h3>
          <p>+91 9008522366</p>

          <h3>Email Us Now</h3>
          <p>info@venturebiz.in </p>
          <p>hr@venturebiz.in</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
